<template>
  <div class="message-center">
    <div class="wrapper">
      <h1>Message Center</h1>
      <input type="text" placeholder="From" v-model.trim="from" />
      <input type="text" placeholder="Subject" v-model.trim="subject" />
      <DropDown
        :options="users"
        :displayKey="'fullName'"
        :isOpened="isOpened"
        @set-opened="handleSetOpened"
        :id="0"
        @get-value="handleGetValue"
        :placeholder="'Select Users'"
        :selectAll="checkBoxBool"
      />
      <div class="select-all">
        <input type="checkbox" v-model="checkBoxBool"/>
        <span>
          {{ $t("dropDown.selectAll") }}
        </span>
      </div>
      <quillEditor v-model="body" ref="myQuillEditor" />
      <button @click="handleSubmit">
        {{ $t("messageCenter.send") }}
      </button>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import DropDown from "@/components/list-of-attendees/DropDown";

import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    quillEditor,
    DropDown,
  },
  data() {
    return {
      users: [],
      isOpened: false,
      selectedUsers: [],
      from: "",
      subject: "",
      body: "",
      checkBoxBool: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getUsers();
    },
    async getUsers() {
      try {
        const res = await api.getUsers({ limit: 999, offset: 0 });
        this.users = res.data.result.map((user) => {
          return {
            ...user,
            fullName: user.usr_firstname + " " + user.usr_lastname,
          };
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    handleSetOpened() {
      this.isOpened = !this.isOpened;
    },
    handleGetValue(users) {
      this.selectedUsers = users;
    },
    async handleSubmit() {
      const userIds = this.selectedUsers.map((user) => user.usr_id);
      const params = {
        from: this.from,
        subject: this.subject,
        tos: userIds,
        body: this.body,
      };
      console.log(params)
      if (!this.from || !this.subject || !userIds || !this.body) {
        this.EventBus.$emit("error", {
          message: "Please fill all fields",
        });
        return;
      }
      const regex = /^(\w+.?)+@(\w+.?)+.\w+$/;
      const test = regex.test(this.from);
      if (!test) {
        this.EventBus.$emit("error", {
          message: "Invalid E-mail",
        });
        return;
      }
      try {
        let res = await api.sendEmail(params);
        this.from = "";
        this.subject = "";
        this.body = "";
        this.selectedUsers = [];
        this.EventBus.$emit("info", {
          message: "E-mail successfully sent!",
        });
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped lang='scss'>
* {
  box-sizing: border-box;
}
.message-center {
  padding: 50px;
  .wrapper {
    width: 80%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    .select-all {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      input {
        margin: 0;
      }
    }
    input {
      display: inline-block;
      width: 50%;
      margin: 0 0 20px 0;
    }
    button {
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;
      white-space: nowrap;
      border: none;
      padding: 10px 23px;
      font-size: 11px;
      border-radius: 100px;
      margin-right: 10px;
      margin-top: 20px;
      background: var(--button-color-blue);
      color: white;
    }
  }
}
</style>

<style lang='scss'>
.message-center {
  .quill-editor {
    margin: 20px 0 0 0;
    .ql-editor,
    .ql-toolbar {
      background: #fff;
    }
  }
}
</style>